const translations = {
    back: 'Back'
};

export default translations;
